//#region IMPORT
import { useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../Reducer/SnackbarReducer';
import useCompanyCustDepRedux from '../../hooks/useCompanyCustDep';
import { useSearch1 } from './MemberInfoModal_QUERY';
//#endregion

//#region 상수
// 화면 MENU_ID
const SCREEN_MENU_ID = 'MemberInfoModal';
//#endregion

function useMemberInfoModal({ onSelection = null, multiYn = 'N' }) {
  //#region 변수
  const dispatch = useDispatch();
  const searchInfo = useSelector((state) => state.SearchInfo);
  const { userInfo } = useSelector((state) => state.BaseInfo);

  const { validateSelection } = useCompanyCustDepRedux({
    requireCompany: true,
    requireCust: true,
  });

  const [modalOpen, setModalOpen] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState([]);
  const gridRef = useRef();
  //#endregion

  //#region 쿼리
  // 회원정보 모달 조회
  const { refetch: Search1 } = useSearch1({
    onSuccess: (rows) => {
      setRowData(rows || []);
    },
  });

  const SearchLogic = async () => {
    if (!validateSelection()) {
      dispatch(
        showSnackbar({
          message: '회사와 사업장을 선택해주세요.',
          type: 'warning',
        })
      );
      return;
    }

    await Search1();
  };
  //#endregion

  //#region handlers
  const handleOpen = async () => {
    setRowData([]);
    setSelectedRowData([]);
    await SearchLogic();
    setModalOpen(true);
  };

  const handleClose = () => {
    setModalOpen(false);
    setRowData([]);
    setSelectedRowData([]);
    gridRef.current?.api?.deselectAll();
  };

  const handleSelection = (selectedFromEvent = null) => { // selectedFromEvent 더블클릭했을때
    const selected = multiYn === 'Y'
      ? selectedFromEvent ? [selectedFromEvent] : selectedRowData
      : selectedFromEvent ?? selectedRowData?.[0];

    if (!selected) {
      dispatch(
        showSnackbar({
          message: '회원을 선택해주세요.',
          type: 'warning',
        })
      );
      return;
    }

    if (onSelection) {
      onSelection(selected);
    }

    handleClose();
  };
  //#endregion

  return {
    modal: {
      open: modalOpen,
      onOpen: handleOpen,
      onClose: handleClose,
    },
    grid: {
      ref: gridRef,
      rowData,
      selectedRowData,
      setSelectedRowData,
    },
    handlers: {
      onSelection: handleSelection,
      onDoubleClick: handleSelection,
    },
  };
}

export default useMemberInfoModal;
